import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
} from "antd";
import axios from "axios";

import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { PlusOutlined } from "@ant-design/icons";
import config from "../../config";
import authHeader from "../Authentication/authHeader";
import dayjs from "dayjs";
import ReactQuill from "react-quill";

export default function POModal({
  visible,
  modalClose,
  data,
  isUpdate,
  userProfile,
  fetchPoList,
}) {
  const [form] = Form.useForm();
  const { Option } = Select;
  const [loading, setLoading] = useState(false);
  const [supplierList, setSupplierList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [centerList, setCenterList] = useState([]);

  const defaultTerms = `
    <p><strong>Terms &amp; Conditions:</strong></p>
    <ol>
      <li>100% Advance payment</li>
      <li>Products will be delivered to the Agrigate Center</li>
      <li>Delivery cost covered by Agrigate</li>
    </ol>
  `;

  useEffect(() => {
    if (isUpdate) {
      form.setFieldsValue({
        terms_conditions: data?.terms_conditions,
      });
    } else {
      form.setFieldsValue({
        terms_conditions: defaultTerms,
      });
    }
  }, [form, isUpdate, data, defaultTerms]);

  useEffect(() => {
    if (userProfile && !isUpdate) {
      form.setFieldsValue({
        prepared_by_user_id: userProfile?.employee_id,
      });
    }
  }, [userProfile, form, isUpdate]);

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/inventory/center_list/`, {
        headers: authHeader(),
      })
      .then((response) => {
        setCenterList(response?.data);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/inventory/supplier_list`, {
        headers: authHeader(),
      })
      .then((response) => {
        setSupplierList(response?.data || []);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/inventory/purchase_product_list`, {
        headers: authHeader(),
      })
      .then((response) => {
        setProductList(response?.data || []);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  useEffect(() => {
    console.log(data);
    if (data && data?.item_details && data?.item_details.length > 0) {
      form.setFieldsValue({
        prepared_by_user_id: data?.initiated_by,
        supplier_id: data?.supplier,
        po_date: dayjs(data?.po_date),
        delivery_date: dayjs(data?.delivery_date),
        center_id: data?.center_id,
        remarks: data?.remarks,
        total: Number(data?.total_amount),
        terms_conditions: data?.terms_conditions,
        poItems: data?.item_details.map((item) => ({
          ...item,
          size: item?.size || "",
          item_remarks: item?.remarks || "",
          product_id: item?.product?.product_id,
          quantity: Number(item.quantity),
          unit_price: Number(item.unit_price),
          discount: Number(item.discount),
          total_price: Number(item.total_price),
        })),
      });
    }
  }, [data, form, isUpdate]);

  const handleQuantityChange = (value, index) => {
    const newValues = { ...form.getFieldsValue() };
    const rate = parseFloat(newValues.poItems[index].unit_price) || 0;
    const discount = parseFloat(newValues.poItems[index].discount) || 0;
    const quantity = value === "" ? 0 : parseInt(value);
    const calculatedTotalPrice = rate * quantity - discount;

    newValues.poItems[index].total_price = Number(
      calculatedTotalPrice?.toFixed(2)
    );

    form.setFieldsValue({ ...newValues });
    form.validateFields([["poItems", index, "discount"]]);
    calculateTotalPO();
  };

  const handleDiscountAdd = (value, index) => {
    const newValues = form.getFieldsValue();
    const quantity = newValues.poItems[index].quantity;
    const rateKey = newValues.poItems[index].unit_price;

    const calculatedTotalPrice = rateKey * quantity;

    if (value) {
      const discountedTotalPrice = Math.max(calculatedTotalPrice - value, 0);
      newValues.poItems[index].total_price = Number(
        discountedTotalPrice?.toFixed(2)
      );
      form.validateFields([["poItems", index, "discount"]]);
    } else {
      newValues.poItems[index].total_price = Number(
        calculatedTotalPrice?.toFixed(2)
      );
      form.validateFields([["poItems", index, "discount"]]);
    }

    form.setFieldsValue(newValues);
    calculateTotalPO();
  };

  const calculateTotalPO = () => {
    const formValues = form.getFieldsValue();
    const products = formValues.poItems || [];
    const newTotalPriceSum = products.reduce((sum, product) => {
      return sum + (parseFloat(product.total_price) || 0);
    }, 0);

    form.setFieldValue("total", Math.trunc(newTotalPriceSum));
  };

  const handleModalClose = () => {
    form.setFieldsValue({
      prepared_by_user_id: null,
      center_id: null,
      supplier_id: null,
      po_date: null,
      delivery_date: null,
      total: null,
      checked_by: null,
      status: null,
      remarks: null,
      poItems: [],
    });
    modalClose();
  };

  const handlePOCreate = (value) => {
    setLoading(true);
    axios
      .post(`${config.baseUrl}/inventory/create_po/`, value, {
        headers: authHeader(),
      })
      .then((response) => {
        console.log(response);
        if (response?.status === 201) {
          setLoading(false);
          Swal.fire({
            title: "Success",
            text: response?.data?.message,
            confirmButtonText: "Ok",
            icon: "success",
          }).then(() => {
            form.resetFields();
            modalClose();
            fetchPoList();
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
    console.log(value);
  };
  const handlePOUpdate = (value) => {
    value.total = parseFloat(value.total);
    setLoading(true);
    axios
      .patch(`${config.baseUrl}/inventory/update_po/${data?.po_id}/`, value, {
        headers: authHeader(),
      })
      .then((response) => {
        setLoading(false);
        if (response?.status === 200) {
          Swal.fire({
            title: "Success",
            text: response?.data?.message,
            confirmButtonText: "Ok",
            icon: "success",
          }).then(() => {
            form.resetFields();
            modalClose();
            fetchPoList();
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  };

  return (
    <Modal
      title={isUpdate ? "Update Purchase Order" : "Add Purchase Order"}
      open={visible}
      onCancel={handleModalClose}
      footer={false}
      width="70%"
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={isUpdate ? handlePOUpdate : handlePOCreate}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Prepared By">
              <Input
                readOnly
                defaultValue={
                  isUpdate
                    ? data?.initiated_by_name
                    : userProfile?.first_name + " " + userProfile?.last_name
                }
              />
            </Form.Item>
            <Form.Item name="prepared_by_user_id" hidden>
              <Input
                value={
                  isUpdate
                    ? userProfile?.employee_id
                    : data?.prepared_by?.prepared_by_id
                }
                readOnly
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Supplier"
              name="supplier_id"
              rules={[
                {
                  required: true,
                  message: "Supplier required!",
                },
              ]}
            >
              <Select
                placeholder="Select supplier"
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                disabled={
                  isUpdate
                    ? userProfile?.employee_id !==
                      data?.prepared_by?.prepared_by_id
                    : false
                }
              >
                {supplierList?.map((supplier) => (
                  <Option
                    key={supplier?.supplier_id}
                    value={supplier?.supplier_id}
                  >
                    {supplier?.supplier_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="PO Date"
              name="po_date"
              labelCol={{ span: 9 }}
              rules={[
                {
                  required: true,
                  message: "Please select PO date",
                },
              ]}
            >
              <DatePicker className="w-100" format="YYYY-MM-DD" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Delivery Date"
              name="delivery_date"
              labelCol={{ span: 9 }}
              rules={[
                {
                  required: true,
                  message: "Please select delivery date",
                },
              ]}
            >
              <DatePicker className="w-100" format="YYYY-MM-DD" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Receive By Center"
              name="center_id"
              rules={[
                {
                  required: true,
                  message: "Center required!",
                },
              ]}
            >
              <Select
                placeholder="Select center"
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                disabled={
                  isUpdate
                    ? userProfile?.employee_id !==
                      data?.prepared_by?.prepared_by_id
                    : false
                }
              >
                {centerList?.map((center) => (
                  <Option
                    key={center?.center?.employee_id}
                    value={center?.center?.employee_id}
                  >
                    {center?.center_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Form.List name="poItems" initialValue={[{}]}>
          {(fields, { add, remove }) => (
            <>
              <Col lg={4}>
                <Form.Item>
                  <Button
                    size="small"
                    type="default"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                    style={{ color: "#000000" }}
                    disabled={
                      isUpdate
                        ? userProfile?.employee_id !== data?.initiated_by
                        : false
                    }
                  >
                    Items
                  </Button>
                </Form.Item>
              </Col>
              {fields.map(({ key, name, ...restField }, index) => (
                <Space key={index} align="baseline">
                  <Row gutter={16}>
                    <Col span={5}>
                      <Form.Item
                        label="Product Name"
                        name={[name, `product_id`]}
                        rules={[
                          {
                            required: true,
                            message: "Product is required",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select product name"
                          showSearch
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          disabled={
                            isUpdate
                              ? userProfile?.employee_id !==
                                data?.prepared_by?.prepared_by_id
                              : false
                          }
                        >
                          {productList?.map((product, index) => (
                            <Option key={index} value={product.product_id}>
                              {product.product_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      <Form.Item label="Size" name={[name, `size`]}>
                        <Select
                          placeholder="Select size"
                          allowClear
                          showSearch
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          disabled={
                            isUpdate
                              ? userProfile?.employee_id !== data?.initiated_by
                              : false
                          }
                        >
                          <Option value="A Grade">A Grade</Option>
                          <Option value="B Grade">B Grade</Option>
                          <Option value="C Grade">C Grade</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={2}>
                      <Form.Item
                        label="Unit Price"
                        name={[name, `unit_price`]}
                        rules={[
                          {
                            required: true,
                            message: "Please enter unit price",
                          },
                          {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: "Only english number",
                          },
                        ]}
                      >
                        <Input placeholder="Unit Price" />
                      </Form.Item>
                    </Col>
                    <Col span={2}>
                      <Form.Item
                        label="Quantity"
                        name={[name, `quantity`]}
                        rules={[
                          {
                            required: true,
                            message: "PO quantity required",
                          },
                          {
                            pattern: /^[0-9]+$/,
                            message: "Only english number",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Quantity"
                          onChange={(e) =>
                            handleQuantityChange(e.target.value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={2}>
                      <Form.Item
                        label="Discount"
                        name={[name, `discount`]}
                        initialValue={0}
                        rules={[
                          {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: "Only english number",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              const row = getFieldValue(["poItems", name]);
                              const qty = parseFloat(row.quantity) || 0;
                              const unitPrice = parseFloat(row.unit_price) || 0;
                              const discount = parseFloat(value) || 0;

                              const calculatedTotal = qty * unitPrice;

                              if (discount > calculatedTotal) {
                                return Promise.reject(
                                  new Error(
                                    "Discount can not be greater than total price."
                                  )
                                );
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Input
                          placeholder="Discount"
                          onChange={(e) =>
                            handleDiscountAdd(e.target.value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      <Form.Item
                        label="Product Total"
                        name={[name, `total_price`]}
                        rules={[
                          {
                            required: true,
                            message: "Product Total Price required",
                          },
                          {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: "Only english number",
                          },
                        ]}
                        initialValue={0}
                      >
                        <Input placeholder="Product Total Price" readOnly />
                      </Form.Item>
                    </Col>
                    <Col span={5}>
                      <Form.Item label="Remarks" name={[name, `item_remarks`]}>
                        <Input placeholder="Remarks" />
                      </Form.Item>
                    </Col>

                    <Col span={2} className="d-flex align-items-center">
                      {fields.length > 1 && (
                        <Button
                          className="pt-0 mt-0"
                          size="small"
                          disabled={
                            isUpdate
                              ? userProfile?.employee_id !==
                                data?.prepared_by?.prepared_by_id
                              : false
                          }
                          onClick={() => {
                            form.setFieldsValue({
                              total: undefined,
                            });
                            remove(name);
                            calculateTotalPO();
                          }}
                          style={{
                            backgroundColor: "",
                            color: "darkred",
                            borderColor: "darkred",
                          }}
                        >
                          x
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Space>
              ))}
            </>
          )}
        </Form.List>

        <div className="d-flex justify-content-end me-5">
          <Row gutter={16}>
            <Col>
              <Form.Item className="ms-2">
                <Input
                  className="text-center custom-placeholder-color"
                  placeholder="Total"
                  disabled
                  style={{ color: "#46604A", borderColor: "#46604A" }}
                />
              </Form.Item>
            </Col>
            <Col style={{ width: "200px" }}>
              <Form.Item className="ms-1" name="total">
                <Input
                  className="text-center"
                  placeholder="Total"
                  readOnly
                  style={{ color: "#46604A", borderColor: "#46604A" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </div>

        <Form.Item label="Remarks" name="remarks">
          <Input.TextArea rows={2} placeholder="Remarks" />
        </Form.Item>
        <Form.Item
          label="Terms & Conditions"
          name="terms_conditions"
          rules={[
            { required: true, message: "Terms & Conditions is required" },
          ]}
          className="mb-5"
        >
          <ReactQuill
            theme="snow"
            value={form.getFieldValue("terms_conditions")}
            onChange={(content) =>
              form.setFieldsValue({ terms_conditions: content })
            }
            style={{ height: "200px" }}
          />
        </Form.Item>
        <Form.Item>
          <Button
            style={{
              backgroundColor: "#46604A",
              borderColor: "#46604A",
              color: "white",
            }}
            htmlType="submit"
            disabled={
              isUpdate
                ? !(userProfile?.employee_id === data?.initiated_by)
                : false
            }
          >
            {isUpdate ? "Update" : "Submit"}
            {loading && <Spin size="small" style={{ marginLeft: 8 }} />}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
